import { Component, ElementRef, OnInit, ViewChild, NgZone, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { EventsCalendarService } from 'src/app/services/events-calendar/events-calendar.service';
import { PlatformService } from 'src/app/services/platform/platform.service';
import { SubSink } from 'subsink';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';

const place = null as google.maps.places.PlaceResult;
type Components = typeof place.address_components;

@Component({
  selector: 'app-calendar-settings',
  templateUrl: './calendar-settings.page.html',
  styleUrls: ['./calendar-settings.page.scss'],
})

export class CalendarSettingsPage implements OnInit {
  moment: any = moment;

  isMobileDevice: boolean;
  eventCalendarForm: FormGroup;
  subscription = new SubSink();
  showSpinner: boolean = false;
  response_message: string = '';
  hasResponseError: boolean = false;

  showEventsLoader: boolean = false;

  isAddEventOpen: boolean = false;
  myEvents: any = [];
  event: any = null;

  api_key: string = environment.google_calendar_api_key;

  showGoogleAddCheckbox: boolean = true;

  google_calendar_checked: boolean = false;

  req_body: any;
  auth2: any;
  @ViewChild('loginRef', { static: true }) loginElement!: ElementRef;

  @ViewChild('search')
  public searchElementRef: ElementRef;
  public place: google.maps.places.PlaceResult;

  private httpClient2: HttpClient;       //For calling API without interceptor

  constructor(
    private fb: FormBuilder,
    private platform: PlatformService,
    private modalCtrl: ModalController,
    private toast: ToastController,
    private eventService: EventsCalendarService,
    private ngZone: NgZone,
    private alertCtrl: AlertController,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    handler: HttpBackend
  ) {
    this.isMobileDevice = this.platform.isMobile();
    this.httpClient2 = new HttpClient(handler);       //For calling API without interceptor
  }

  ngOnInit() {
    this.showEventLoader();
    this.readyCalendarForm();
    this.getMyEventsInfo();
  }

  ngAfterViewInit() {
    this.initializeAutocomplete();
  }

  readyCalendarForm() {
    this.eventCalendarForm = this.fb.group({
      event_title: ['', [Validators.required, Validators.pattern(/\S+/)]],
      event_date: [null, Validators.required],
      event_end_date: [null, Validators.required],
      event_start_time: [null, Validators.required],
      event_end_time: [null, Validators.required],
      all_day_event: [false, Validators.required],
      repeat_event: '',
      event_description: ['', Validators.pattern(/\S+/)],
      where_event: ['', [Validators.required, Validators.pattern(/\S+/)]],
      event_address: ['', [Validators.required, Validators.pattern(/\S+/)]],
      lat: [null, Validators.required],
      long: [null, Validators.required],
      google_calendar_add: false,
    });
    this.eventCalendarForm.reset();
  }

  initializeAutocomplete() {
    const input = document.getElementById("event_address") as HTMLInputElement;
    const options = {
      fields: ["formatted_address", "geometry", "name"],
      strictBounds: false,
      types: ["establishment"],
    };
    const autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        this.onPlaceChange(autocomplete.getPlace());
      });
      const place = autocomplete.getPlace();
      let complete_address = place.name + ", " + place.formatted_address;
      // console.log("address --> ", complete_address);
      this.eventCalendarForm.get('event_address').setValue(complete_address);
    });
  }

  onPlaceChange(place: google.maps.places.PlaceResult) {
    var latitude = place.geometry.location.lat();
    var longitude = place.geometry.location.lng();
    this.eventCalendarForm.get('lat').setValue(latitude);
    this.eventCalendarForm.get('long').setValue(longitude);
    // console.log("latitude --> ", latitude, "longitude --> ",longitude);
  }

  invalidateTime() {
    if (this.eventCalendarForm.value.all_day_event) {
      this.eventCalendarForm.get('event_start_time').setValue(null);
      this.eventCalendarForm.get('event_end_time').setValue(null);
      this.eventCalendarForm.controls['event_start_time'].disable();
      this.eventCalendarForm.controls['event_start_time'].clearValidators();
      this.eventCalendarForm.controls['event_end_time'].disable();
      this.eventCalendarForm.controls['event_end_time'].clearValidators();
    } else {
      this.eventCalendarForm.controls['event_start_time'].enable();
      this.eventCalendarForm.controls['event_start_time'].setValidators([Validators.required]);
      this.eventCalendarForm.controls['event_end_time'].enable();
      this.eventCalendarForm.controls['event_end_time'].setValidators([Validators.required]);
    }
    this.eventCalendarForm.controls['event_start_time'].updateValueAndValidity();
    this.eventCalendarForm.controls['event_end_time'].updateValueAndValidity();
  }

  invalidateAllDay() {
    // this.eventCalendarForm.controls['all_day_event'].disable();
    this.eventCalendarForm.controls['all_day_event'].clearValidators();
    this.eventCalendarForm.controls['all_day_event'].updateValueAndValidity();
  }

  invalidateTimeCopy() {
    if (this.eventCalendarForm.value.all_day_event) {
      this.eventCalendarForm.get('event_start_time').setValue(null);
      this.eventCalendarForm.get('event_end_time').setValue(null);
      this.eventCalendarForm.controls['event_start_time'].disable();
      this.eventCalendarForm.controls['event_start_time'].clearValidators();
      this.eventCalendarForm.controls['event_end_time'].disable();
      this.eventCalendarForm.controls['event_end_time'].clearValidators();
    } else {
      this.eventCalendarForm.controls['event_start_time'].enable();
      this.eventCalendarForm.controls['event_start_time'].setValidators([Validators.required]);
      this.eventCalendarForm.controls['event_end_time'].enable();
      this.eventCalendarForm.controls['event_end_time'].setValidators([Validators.required]);
      this.invalidateAllDay();
    }
    this.eventCalendarForm.controls['event_start_time'].updateValueAndValidity();
    this.eventCalendarForm.controls['event_end_time'].updateValueAndValidity();
    this.event !== null ? this.eventCalendarForm.markAsPristine() : '';
  }

  //GETTERS
  get event_title() {
    return this.eventCalendarForm.get('event_title');
  }
  get event_date() {
    return this.eventCalendarForm.get('event_date');
  }
  get event_end_date() {
    return this.eventCalendarForm.get('event_end_date');
  }
  get all_day_event() {
    return this.eventCalendarForm.get('all_day_event');
  }
  get event_description() {
    return this.eventCalendarForm.get('event_description');
  }
  get start_time() {
    return this.eventCalendarForm.get('event_start_time');
  }
  get end_time() {
    return this.eventCalendarForm.get('event_end_time');
  }
  get repeat_event() {
    return this.eventCalendarForm.get('repeat_event');
  }
  get where_event() {
    return this.eventCalendarForm.get('where_event');
  }
  get event_address() {
    return this.eventCalendarForm.get('event_address');
  }
  get lat() {
    return this.eventCalendarForm.get('lat');
  }
  get long() {
    return this.eventCalendarForm.get('long');
  }
  get google_calendar_add() {
    return this.eventCalendarForm.get('google_calendar_add');
  }
  //GETTERS

  setRepeatEvent(event, value) {
    if (event.target.checked) {
      this.repeat_event.setValue(value);
    } else {
      this.repeat_event.setValue('');
    }

    this.repeat_event.markAsDirty();
    // console.log("VALUE",this.repeat_event.value);
  }

  emptyLatLong(ev){
    if (ev.which == 8 || ev.which == 46 || ev.which == 17) {          //empty on pressing backspace/delete/ctrl
      this.eventCalendarForm.get('lat').setValue(null);
      this.eventCalendarForm.get('long').setValue(null);
    }
  }

  contextFunc() {
    return false;    //to disable right click context menu
  }

  getMyEventsInfo() {
    this.google_calendar_checked = false;
    this.subscription.sink = this.eventService
      .getMyEvents()
      .subscribe(
        (res_myEvents: any) => {
          this.showEventsLoader = false;
          this.myEvents = res_myEvents.data;
          // console.log("my events data ---> ",this.myEvents);
        },
        (error) => {
          this.showEventsLoader = false;
          console.log(error);
        }
      );
  }

  insertGoogleCalendarEvent(email, access_token) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${access_token}`,
    };
    this.subscription.sink = this.httpClient2.post(`https://content.googleapis.com/calendar/v3/calendars/${email}/events?alt=json&key=${this.api_key}`, this.req_body, {
      headers: new HttpHeaders(headers),
    }).subscribe(
      (res: any) => {
        // console.log("insert resp ==> ", res);
        this.response_message = "Event added to Google Calendar successfully";
        this.presentSuccessToast(this.response_message);
      }, (error) => {
        // console.log("insert error ==> ", error);
        this.response_message = "A problem occurred while adding event to your Google Calendar, try again later."
        this.presentErrorToast(this.response_message);
      });
  }


  googleAuthSDK() {
    // console.log("google auth sdk called");
    (<any>window)['googleSDKLoaded'] = () => {
      (<any>window)['gapi'].load('auth2', () => {
        this.auth2 = (<any>window)['gapi'].auth2.init({
          client_id: '138701212350-asq6m4uk031kbcie8pudep6h80etj303.apps.googleusercontent.com',
          plugin_name:'login',
          cookiepolicy: 'single_host_origin',
          scope: 'https://www.googleapis.com/auth/calendar'
        });
        this.callLogin();
      });
    }

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement('script');
      js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
      fjs?.parentNode?.insertBefore(js, fjs);
    }(document, 'script', 'google-jssdk'));
  }


  callLogin() {
    // console.log("== login called ==");
    // console.log('login element => ',this.loginElement);
    this.auth2.attachClickHandler(this.loginElement.nativeElement, {},
      (googleAuthUser: any) => {
        //Print profile details in the console logs
        let profile = googleAuthUser.getBasicProfile();
        // console.log('Access Token || ' + googleAuthUser.getAuthResponse().access_token);
        // console.log('Token || ' + googleAuthUser.getAuthResponse().id_token);
        // console.log('Name: ' + profile.getName());
        // console.log('Email: ' + profile.getEmail());
        let email = profile.getEmail();
        let access_token = googleAuthUser.getAuthResponse().access_token;
        this.submitEventCalendar();
        this.insertGoogleCalendarEvent(email, access_token);
      }, (error: any) => {
        // console.log("login error => ", error);
        this.submitEventCalendar();
        this.response_message = "Google login failed. Event was not added to Google Calendar.";
        this.presentErrorToast(this.response_message);
      });

  }

  google_add_change() {
    // console.log("google add change");
    this.google_calendar_checked = this.eventCalendarForm.value.google_calendar_add;
    if (this.google_calendar_checked) {
      this.googleAuthSDK();
    }
  }


  submitEventCalendar() {
    let eventInfo = this.eventCalendarForm.value;
    // console.log('form data ---------->', eventInfo);
    if(eventInfo.all_day_event) {
      this.req_body = {
        start: {
          date: eventInfo.event_date
        },
        end: {
          date: eventInfo.event_end_date
        },
        summary: eventInfo.event_title,
        description: eventInfo.event_description,
        location: eventInfo.event_address
      }
    } else {
      this.req_body = {
        start: {
          dateTime: eventInfo.event_date + 'T' + eventInfo.event_start_time + ':00+05:00'
        },
        end: {
          dateTime: eventInfo.event_end_date + 'T' + eventInfo.event_end_time + ':00+05:00'
        },
        summary: eventInfo.event_title,
        description: eventInfo.event_description,
        location: eventInfo.event_address
      }
    }

    this.subscription.sink = this.eventService
      .createCalendarEvent(eventInfo)
      .subscribe(
        (res: any) => {
          this.getMyEventsInfo();
          this.showSpinner = false;
          this.cdr.detectChanges();
          // console.log('create contact response ----------> ', res);
          this.google_calendar_checked = false;
          this.hasResponseError = false;
          this.response_message = res.message;
          this.presentSuccessToast(this.response_message);
          this.eventCalendarForm.reset();
          this.invalidateTimeCopy();
          this.isAddEventOpen = false;
          this.cdr.detectChanges();
        },
        (err: any) => {
          this.showSpinner = false;
          this.cdr.detectChanges();
          this.google_calendar_checked = false;
          console.log('Error -------> ', err);
          this.hasResponseError = true;
          this.response_message = "An error occurred adding your Event, please try again later.";
          this.presentErrorToast(this.response_message);
        }
      );

  }

  getEvent(id) {
    this.subscription.sink = this.eventService
      .getCalendarEvent(id)
      .subscribe(
        (res: any) => {
          this.event = res.data;
          // console.log("event ==> ",this.event);
          this.readyEditFormData(this.event);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  openAddEvent() {
    this.showGoogleAddCheckbox = true;
    this.isAddEventOpen = true;
    this.event = null;
    this.eventCalendarForm.reset();
  }

  goBackToEventsList() {
    this.showSpinner = false;
    this.isAddEventOpen = false;
    this.showGoogleAddCheckbox = true;
    this.event = null;
    this.eventCalendarForm.reset();
  }

  goToEditForm(id) {
    // console.log("event id --> ", id);
    this.showGoogleAddCheckbox = false;
    this.getEvent(id);
  }

  readyEditFormData(event) {
    this.eventCalendarForm.patchValue({
      event_title: event.event_title,
      event_date: event.event_date,
      event_end_date: event.event_end_date,
      event_start_time: event.event_start_time ?? null,
      event_end_time: event.event_end_time ?? null,
      all_day_event: event.all_day_event,
      repeat_event: event.repeat_event ?? '',
      event_description: event.event_description ?? '',
      where_event: event.where_event,
      event_address: event.event_address,
      lat: event.lat ?? null,
      long: event.long ?? null,
      google_calendar_add: event.sync_google_calendar ?? false
    });
    this.isAddEventOpen = true;
    this.invalidateTimeCopy();
  }

  updateEvent(id) {
    this.showSpinner = true;
    // console.log("update event id --> ",id);
    let eventInfo = this.eventCalendarForm.value;
    if(this.eventCalendarForm.value.all_day_event) {
      eventInfo['event_start_time'] = null;
      eventInfo['event_end_time'] = null;
    }
    // console.log('form value  ---------->', this.eventCalendarForm.value);
    this.subscription.sink = this.eventService
        .updateCalendarEvent(id, eventInfo)
        .subscribe(
          (res: any) => {
            this.showSpinner = false;
            // console.log('update event response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);

            this.eventCalendarForm.reset();
            this.invalidateTimeCopy();
            this.isAddEventOpen = false;
            this.getMyEventsInfo();
          },
          (err: any) => {
            this.showSpinner = false;
            console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred updating your Event, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
  }

  deleteEvent(id) {
    // console.log("delete event id --> ",id);
    this.subscription.sink = this.eventService
        .deleteCalendarEvent(id)
        .subscribe(
          (res: any) => {
            // console.log('delete event response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);
            this.getMyEventsInfo();
          },
          (err: any) => {
            console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred deleting your Event, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
  }

  showEventLoader() {
    this.showEventsLoader = true;
  }


  closeModal() {
    return this.modalCtrl.dismiss();
  }

  async deleteConfirm(event_id) {
    let alert = this.alertCtrl.create({
      message: 'Are you sure, you want to delete this event?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            // console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirm',
          handler: () => {
            this.deleteEvent(event_id);
          }
        }
      ]
    });
    (await alert).present();
  }

}
